var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.periodOption.length > 1
        ? _c("dt-form-item", {
            attrs: {
              label: _vm.periodTypeLabel,
              inputType: "select",
              options: _vm.periodOption,
            },
            model: {
              value: _vm.periodType,
              callback: function ($$v) {
                _vm.periodType = $$v
              },
              expression: "periodType",
            },
          })
        : _vm._e(),
      _c("dt-form-item", {
        key: _vm.periodType,
        attrs: {
          inputType: "date-picker",
          label: _vm.periodLabel,
          componentAttr: {
            type: _vm.periodType,
            format: _vm.pickerProps[_vm.periodType].format,
            pickerOptions: {
              firstDayOfWeek: 1,
              disabledDate: _vm.disabledDate,
              onPick: function (newTempValue) {
                return Object.assign(_vm.tempValue, newTempValue)
              },
            },
            placeholder: _vm.pickerProps[_vm.periodType].placeholder,
            startPlaceholder: "开始日期",
            endPlaceholder: "结束日期",
            unlinkPanels: true,
            clearable: _vm.clearable,
          },
        },
        on: { change: _vm.updateValue },
        model: {
          value: _vm.value_,
          callback: function ($$v) {
            _vm.value_ = $$v
          },
          expression: "value_",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }